import React, {useRef} from 'react';
import {useEffect, useState} from 'react'
import zhCN from 'antd/lib/locale/zh_CN'
import {
  SDrawerOrModal, SFuncModal, SGeneralForms, SListTabs,
} from 'shj-components'
import {Form, Input, DatePicker, InputNumber, ConfigProvider} from 'antd';
import dayjs from 'dayjs';
import {ModalDesignNameDom} from "./modals/MasterDom.tsx";
import {ModalArtDesignFnlDom} from "./modals/EditDesigner.tsx";
import {ModalVersionProject} from "./modals/DesignHistory.tsx";
import {findMoaFlag} from "@/services/kuAccount.ts";

export default function ProposalMasterModal({
                                              editId = '',
                                              record = {},
                                              open = false,
                                              basicInfo = {},
                                              onClose = () => {
                                              },
                                              reload = () => {
                                              },
                                            }) {

  const [moaFlag, setMoaFlag] = useState();

  useEffect(() => {
    findMoaFlag(editId).then((resp: any) => {
      // console.log('是否当前负责人Pri:::', resp);
      setMoaFlag(resp);
    });
  }, []);

  const items = [
    {
      key: '1',
      label: '提案大师',
      children: (
          <ConfigProvider locale={zhCN}>
            <ModalDesignNameDom
                bizId={record?.id || editId}
                // listRef={listRef}
                onUpdate={reload}
                moaFlag={moaFlag}
                fn
                key={`name` + (record?.id || editId) + Math.random()}
            />
            <ModalArtDesignFnlDom
                bizId={record?.id || editId}
                record={record}
                onUpdate={reload}
                moaFlag={moaFlag}
                fn
                key={`menber` + (record?.id || editId)}
            />
          </ConfigProvider>
      ),
    },
    {
      key: '2',
      label: '历史方案',
      children: <ModalVersionProject bizId={record?.id || editId} moaFlag={moaFlag}/>,
    },
  ]

  return (
      <div>
        <SDrawerOrModal
            mode="drawer"
            width={1000}
            open={open}
            onCancel={() => onClose()}
            // loading={loading}
            title="提案大师"
            antdProps={{
              footer: []
            }}
        >
          <SListTabs items={items} auth={true} hideExtra destroyInactiveTabPane/>
        </SDrawerOrModal>
      </div>
  )
}
